const WP_API = 'https://topic.moyuksaiwaidental.jp/wp-json/wp/v2';

export interface WPPost {
  id: number;
  slug: string;
  date: string;
  title: { rendered: string };
  excerpt: { rendered: string };
  content: { rendered: string };
  categories: number[];
  _embedded?: {
    'wp:featuredmedia'?: Array<{ source_url: string; alt_text: string }>;
    'wp:term'?: Array<Array<{ id: number; name: string; slug: string }>>;
  };
}

export interface WPCategory {
  id: number;
  name: string;
  slug: string;
  count: number;
}

export async function fetchPosts(
  page = 1,
  perPage = 12,
  categoryId?: number
): Promise<{ posts: WPPost[]; total: number; totalPages: number }> {
  const params = new URLSearchParams({
    _embed: '1',
    per_page: String(perPage),
    page: String(page),
    orderby: 'date',
    order: 'desc',
  });
  if (categoryId) params.set('categories', String(categoryId));

  const res = await fetch(`${WP_API}/column?${params}`);
  if (!res.ok) throw new Error('記事の取得に失敗しました');

  const posts: WPPost[] = await res.json();
  const total = Number(res.headers.get('X-WP-Total') || 0);
  const totalPages = Number(res.headers.get('X-WP-TotalPages') || 1);

  return { posts, total, totalPages };
}

export async function fetchPostBySlug(slug: string): Promise<WPPost | null> {
  const res = await fetch(`${WP_API}/column?slug=${slug}&_embed`);
  if (!res.ok) return null;
  const posts: WPPost[] = await res.json();
  return posts[0] ?? null;
}

export async function fetchCategories(): Promise<WPCategory[]> {
  const res = await fetch(`${WP_API}/categories?per_page=100&orderby=count&order=desc&hide_empty=true`);
  if (!res.ok) return [];
  return res.json();
}

export async function fetchNews(): Promise<WPPost[]> {
  const res = await fetch(`${WP_API}/news?_embed&per_page=100&orderby=date&order=desc`);
  if (!res.ok) return [];
  return res.json();
}

export async function fetchNewsBySlug(slug: string): Promise<WPPost | null> {
  const res = await fetch(`${WP_API}/news?slug=${slug}&_embed`);
  if (!res.ok) return null;
  const posts: WPPost[] = await res.json();
  return posts[0] ?? null;
}

export function stripHtml(html: string): string {
  return html.replace(/<[^>]*>/g, '').trim();
}

export function formatDate(dateStr: string): string {
  const d = new Date(dateStr);
  return `${d.getFullYear()}年${d.getMonth() + 1}月${d.getDate()}日`;
}
